import { GameLoader } from "../loaders/GameLoader";
import {TypeRunLobbyGame} from "../../global";

export class LobbyService {
    constructor(
        public gameLoader: GameLoader,
        public iframe: HTMLIFrameElement
    ) {
        window.addEventListener("run-game", (event: CustomEvent<TypeRunLobbyGame>) =>
            this.onGameChange(event["detail"])
        );
    }

    onGameChange(game: TypeRunLobbyGame): void {
        try {
            if (!game) {
                throw new Error(`[InGameLobby] You can not open empty game object!`);
            }

            if (!game || !game.openAs?.trim()) {
                throw new Error(`[InGameLobby] You can not run game with empty "game.openAs"!`);
            }

            if (game.url && game.url.trim()) {
                if (!URL.canParse(game.url.trim())) {
                    throw new Error(`[InGameLobby] Game "url" is not valid URL!`);
                }

                if (this.gameLoader.activePromoWidget) {
                    const message = {
                        from: "GAME",
                        to: "PROMO",
                        action: "reloadByUrl",
                        payload: game.url.toString()
                    };
                    window.parent.postMessage(message, "*");
                    return;
                }

                window.location.href = game.url;
                return;
            }

            const finalURL = this.gameLoader.generateUrl(game.openAs);

            const url = new URL(finalURL);
            url.searchParams.set("gameName", game.openAs);
            url.searchParams.set("reenter", "1");
            url.searchParams.set("_t", Date.now().toString());

            this.iframe.setAttribute("src", url.toString());
        } catch (error: any) {
            window.dispatchEvent(
                new CustomEvent("run-game-error", {
                    detail: /TypeError:/.test(error.toString())
                        ? "Client error"
                        : error.message,
                })
            );

            console.error("[Bash][lobby] Re-enter error: ", error);
        }
    }
}
